// import components
import { ControlledRadioGroup } from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

// import external libraries
import { useTranslation } from 'react-i18next';

const DtrContent = ({ control }) => {
  const { t } = useTranslation('common', { keyPrefix: 'costCenterSettings' });

  return (
    <MultiStepForm.Section title={t('dtrCalculation.title')}>
      <ControlledRadioGroup
        control={control}
        name="dtr_calculation_enabled"
        label={''}
        options={[
          { label: t('dtrCalculation.yes'), value: 'true' },
          { label: t('dtrCalculation.no'), value: 'false' }
        ]}
        direction="row"
      />
    </MultiStepForm.Section>
  );
};

export default DtrContent;
